import React, { Component } from "react";
import ApiClient from "../../../../../utils/ApiClient";

export default class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsLeft: 5,
      statusMessage: "Finalizing your order...",
      orderId: null,
    };
    this.timer = null;
    this.formRef = React.createRef();
  }

  async componentDidMount() {
    try {
      // Extract form data from HDFC POST
      const formData = new FormData(this.formRef.current);
      const orderId = formData.get("order_id");
      const status = formData.get("status");

      if (!orderId) {
        this.setState({ statusMessage: "Order ID missing in payment payload." });
        setTimeout(() => {
          window.location.href = "/order/failed";
        }, 3000);
        return;
      }

      this.setState({ orderId });

      if (status !== "CHARGED") {
        this.setState({ statusMessage: "Payment not successful." });
        setTimeout(() => {
          window.location.href = "/order/failed";
        }, 3000);
        return;
      }

      // Call backend to finalize order
      const finalizeResponse = await ApiClient.get(
        `https://jccreations.boutique/api/order/webhdfcresponse?order_id=${orderId}`
      );

      if (finalizeResponse.success) {
        this.setState({ statusMessage: "Transaction successful! Finalizing your order..." });

        // Start countdown before redirect
        this.timer = setInterval(() => {
          this.setState((prevState) => {
            if (prevState.secondsLeft <= 1) {
              clearInterval(this.timer);
              window.location.href = "/account/order/list";
              return { secondsLeft: 0 };
            }
            return { secondsLeft: prevState.secondsLeft - 1 };
          });
        }, 1000);
      } else {
        this.setState({ statusMessage: "Payment failed or could not finalize order." });
        setTimeout(() => {
          window.location.href = "/order/failed";
        }, 3000);
      }
    } catch (err) {
      console.error(err);
      this.setState({ statusMessage: "Error finalizing order." });
      setTimeout(() => {
        window.location.href = "/order/failed";
      }, 3000);
    }
  }

  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer);
  }

  render() {
    const { secondsLeft, statusMessage } = this.state;

    return (
      <div className="card checkout-step-one">
        <section className="breadcrumb-bg mt-5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-12 text-center">
                <div className="page-title order-done">
                  <i
                    className="mdi mdi-check-circle-outline text-success"
                    style={{ fontSize: "14rem" }}
                  />
                  <h1 className="mt-3">Transaction Successful</h1>
                  <p className="col-sm-6 mx-auto mt-3 mb-2">{statusMessage}</p>
                  <p>
                    {secondsLeft > 0 &&
                      `Redirecting to your orders page in ${secondsLeft} seconds...`}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Hidden form HDFC posts to */}
        <form
          ref={this.formRef}
          method="POST"
          style={{ display: "none" }}
          id="hdfc-payload-form"
        >
          {/* HDFC posts these fields */}
          <input type="hidden" name="status" />
          <input type="hidden" name="status_id" />
          <input type="hidden" name="signature" />
          <input type="hidden" name="signature_algorithm" />
          <input type="hidden" name="order_id" />
        </form>
      </div>
    );
  }
}
